import React from "react";
import LegacyOwnerHome from "./OwnerCommandCenterPage";

export default function OwnerCommandCenterHomePage() {
  return <LegacyOwnerHome />;
}
